import { ModelBase } from '../shared/model.base';
import { ShortCodeCompany } from './shortCodesCompany.type';

export class OperatorCompany extends ModelBase {
  operator_id: number;
  organization_id: number;

  ShortCodes: Array<ShortCodeCompany>;

  constructor() {
    super();
  }
}
